import React from 'react';
import { bool, string } from 'prop-types';
import classNames from 'classnames';

import css from './AddImagesField.css';
import VideoPlaceholderIcon from './VideoPlaceholderIcon';
import AddImageIcon from './AddImageIcon';
import UploadIcon from './UploadIcon';
import IconSpinner from '../IconSpinner/IconSpinner';
import { ImagePlaceholderIconVertical } from '../../icons';
import IconRect from './IconRect';

const ACCEPT_IMAGES = 'image/video/*';

const AddImagesField = props => {
    const {
        dragOverFORM,
        inputProps = {},
        disabled,
        name,
        multiple = true,
        initialState,
        inProgress = false,
        imagesUploaded = 0,
        init,
    } = props;

    const onClick = disabled ? undefined : init;

    const inputAttributes = { name, id: name, type: 'file', accept: ACCEPT_IMAGES, ...inputProps };

    if (initialState) {
        return (
            <div
                onClick={onClick}
                className={classNames(css.initialStateHolder, {
                    [css.imageDraggedOver]: !!dragOverFORM,
                })}
            >
                <IconRect />
                <input
                    {...inputAttributes}
                    name={name}
                    className={`AddImagesField_addImageInput_${name}`}
                    multiple={multiple}
                    accept={ACCEPT_IMAGES}
                />
                {/* <label htmlFor={name} className={css.initialStateLabel}> */}
                <div className={css.initialStateLabel}>
                    <UploadIcon />
                    <p>Fotos und Videos hochladen</p>
                    <p>Hierhin ziehen oder auswählen</p>
                    <p>
                        <span>.JPG und .PNG max. 50 MB</span>
                        <span>.MP4 und .MOV max. 250 MB</span>
                    </p>
                </div>
                {/* </label> */}
            </div>
        );
    }

    const elements = [
        <ImagePlaceholderIconVertical />,
        <VideoPlaceholderIcon />,
        <ImagePlaceholderIconVertical />,
    ]
        .filter((_, i) => i > imagesUploaded - 2)
        .concat(
            <>
                <AddImageIcon />
                <span>Weitere hinzufügen</span>
            </>
        );

    return elements.map((elem, index) => (
        <div key={index} className={css.addImageWrapper} onClick={onClick}>
            <div
                className={classNames(css.aspectRatioWrapper, {
                    [css.imageDraggedOver]: !!dragOverFORM,
                })}
            >
                {disabled ? null : (
                    <input
                        {...inputAttributes}
                        className={`AddImagesField_addImageInput_${name}`}
                        multiple={multiple}
                    />
                )}
                <IconRect />
                {/* <label htmlFor={name} className={css.addImage}> */}
                <div className={css.addImage}>
                    {index === 0 && inProgress ? <IconSpinner /> : elem}
                </div>
                {/* </label> */}
            </div>
        </div>
    ));
};

export default AddImagesField;
